import { cn } from "@bafe/ui";
import { Link } from "react-router";

export interface TabItem {
	id: string;
	label: string;
	to: string;
}

export interface TabNavProps {
	label: string;
	items: TabItem[];
	currentId: string;
}

/**
 * Tabs are URL-addressable so support can send a customer straight to, say,
 * the Devices tab of a mailbox.
 */
export function TabNav({ label, items, currentId }: TabNavProps) {
	return (
		<nav aria-label={label} className="-mx-4 overflow-x-auto px-4 sm:mx-0 sm:px-0">
			<ul className="flex min-w-max gap-1 border-b border-(--border-subtle)">
				{items.map((item) => {
					const active = item.id === currentId;
					return (
						<li key={item.id}>
							<Link
								to={item.to}
								aria-current={active ? "page" : undefined}
								className={cn(
									"-mb-px inline-flex h-10 items-center border-b-2 px-3 text-sm font-medium transition-colors",
									active
										? "border-(--color-brand-600) text-(--text-primary)"
										: "border-transparent text-(--text-secondary) hover:text-(--text-primary)",
								)}
							>
								{item.label}
							</Link>
						</li>
					);
				})}
			</ul>
		</nav>
	);
}
